module.exports = require('./helpers/bundle-url').getBundleURL('gR264') + "AdobeExperienceSubCloud.6e2f998e.svg";